import * as React from 'react';
import { useEffect, useState } from 'react';
// material
import { Grid, Button, Container, Stack, Typography, TextField } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Iconify from '../components/Iconify';
import palette from '../theme/palette';
import { AppWidgetSummary } from '../sections/@dashboard/app';
// components
import Wallet from './Wallet';
import Page from '../components/Page';
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';
// mock
import PRODUCTS from '../_mock/products';
// ----------------------------------------------------------------------

  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
export default function Profile() {
  const [openFilter, setOpenFilter] = useState(false);
  const [lat, setLat] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [lng, setLng] = useState("");
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [withdrawBtn, setWithdrawBtn] = useState("Withdraw");
  const [user, setUser] = useState(
    {
      "status": true,
      "message": "Login successful!",
      "data": {
          "rating": "0",
          "availability": "offline",
          "status": true,
          "role": "artisan",
          "_id": "6303b359ae52850016ba2d95",
          "phone": "9135403118",
          "country_code": "234",
          "id": "6303b359ae52850016ba2d95",
          "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
          "createdAt": "2022-08-22T16:48:25.655Z",
          "updatedAt": "2022-09-01T23:51:54.155Z",
          "__v": 0,
          "address_str": "10 Juliest ultimate Drive",
          "avatar": "avatar",
          "email": "omonicksonowoeye@gmail.com",
          "first_name": "Omoniyi",
          "last_name": "Omoniyi",
          "location": {
              "type": "Point",
              "coordinates": [
                  7.471104,
                  9.0570752
              ],
              "_id": "6311442da0ebe3001607e006"
          },
          "password": "bml5aW5peWk=",
          "username": "worldest",
          "video": "avatar"
      }
    }
  );
  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else { 
      alert("We need your location to improve your experience in the app")
    }
  }
   function BankDetails(){
    return(
        <>
            <TextField
                style={{width: 350}}
                type="number"
                id="account_number"
                label="Enter Acount Number"
                required
            />
            <br />
            <br />
            <TextField
                style={{width: 350}}
                type="text"
                id="account_name"
                label="Enter Account Name"
                required
            />
            <br /><br />
            <TextField
                style={{width: 350}}
                type="text"
                id="bank_name"
                label="Enter Bank Name"
                required
            />
            <br /><br />
            <Button
                color='success'
                variant="outlined"
                style={{width: 350}}
            >Update</Button>
        </>
    )
   }
   function Withdraw(){
    return(
        <>
            <TextField
                style={{width: 350}}
                type="number"
                id="withdraw_amount"
                label="Enter Amount to withdraw"
                required
            />
            
            <br /><br />
            <Button 
                onClick={() => {
                    setWithdrawBtn("Please Wait...")
                    const body = {
                    user_id: user.data._id,
                    amount:  document.getElementById("withdraw_amount").value,
                    };
                    fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/wallets/withdrawal`, {
                    body: JSON.stringify(body),
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                    })
                    .then(resposne => resposne.json())
                    .then(data => {
                        console.log(data);
                        alert(data.message)
                        setWithdrawBtn("Withdraw")
                    })
                    .catch(err => {
                    alert(`Error: ${err}`);
                    setWithdrawBtn("Withdraw")
                    })
                }}
                color='success'
                variant="outlined"
                style={{width: 350}}
            >{withdrawBtn}</Button>
        </>
    )
   }
   function ProfileDetails(){
    return(
        <>
            <TextField
                style={{width: 350}}
                type="number"
                id="first_name"
                value={user.data.first_name}
                label="Enter First Name"
                required
            />
            <br />
            <br />
            <TextField
                style={{width: 350}}
                type="text"
                id="last_name"
                value={user.data.last_name}
                label="Enter Last Name"
                required
            />
            <br /><br />
            <TextField
                style={{width: 350}}
                type="text"
                id="email"
                label="Enter Email"
                value={user.data.email}
                required
            />
            <br /><br />
            <TextField
                style={{width: 350}}
                type="number"
                id="email"
                label="Enter Phone"
                value={user.data.phone}
                required
            />
            <br /><br />
            <TextField
                style={{width: 350}}
                type="text"
                id="address"
                label="Enter Address"
                value={user.data.address_str}
                required
            />
            <br /><br />
            <Button
                color='success'
                variant="outlined"
                style={{width: 350}}
            >Update</Button>
        </>
    )
   }
  function showPosition(position) {
    setLat(position.coords.latitude);
    setLng(position.coords.longitude);
  }
  
  useEffect(() => {
    
    const getUser = localStorage.getItem("user");
    setUser(JSON.parse(getUser));
    
  }, [])
  return (
    <Page title="Profile">
      <Container>
      {
          isVerified === false ?
          <Container  style={{border: "1px solid orange", borderRadius: 10, padding: 15}}>
            <Grid>
              <p>You account is pending approval</p>
              
              <Button onClick={() => {
                window.location.href = "./verify"
              }}>Verify Account</Button>
            </Grid>
            
          </Container>
          :
          <></>
        }
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Wallet" {...a11yProps(0)} />
                <Tab label="Bank Details" {...a11yProps(1)} />
                <Tab label="Withdraw" {...a11yProps(2)} />
                <Tab label="Reviews" {...a11yProps(3)} />
                <Tab label="Profile" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <Wallet />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <BankDetails />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <Withdraw />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <h4>Reviews From Projects</h4>
                <p>Ooops! No reviews</p>
            </TabPanel>
            <TabPanel value={value} index={4}>
                <ProfileDetails />
            </TabPanel>
        </Box>      
      </Container>
    </Page>
  );
}
